<template>
    <div>
        <el-row class="u-mt-10 u-mb-20">
            <el-col :xs="24" :sm="16" :md="16">
                <el-input v-model="filtro['nome']" placeholder="Pesquisar bairro..." @keyup.native.enter="loadingBairros"></el-input>
            </el-col>
            <el-col :xs="24" :sm="8" :md="8" class="u-text-right">
                <router-link to="/admin/bairro/cadastro" class="btn-new-register">
                    <el-button type="primary">NOVO BAIRRO</el-button>
                </router-link>
            </el-col>
        </el-row>
        <div class="container-table">
            <table class="table table-striped">
                <thead>
                    <tr>
                        <th class="hidden-mobile" style="width: 70px;">cod</th>
                        <th>Nome</th>
                        <th class="hidden-mobile u-text-center">Situação</th>
                        <th style="width: 150px;" class="u-text-center">Ação</th>
                    </tr>
                </thead>
                <tbody v-if="statusList">
                    <tr v-for="item in items" :key="item.id">
                        <td class="hidden-mobile">{{ item.id }}</td>
                        <td>{{ item.nome | truncate(30, '...') }}</td>
                        <td class="hidden-mobile u-text-center">{{ (item.situacao) ? 'Ativo' : 'Inativo' }}</td>
                        <td class="u-text-center acao"> 
                            <router-link :to="'/admin/bairro/edit/'+ item.id" class="link-icon u-mr-10" style="color: rgba(0, 0, 0, 0.87) !important;">
                                <el-button type="info" title="Editar" icon="el-icon-edit" size="mini" plain></el-button>
                            </router-link>
                            <el-button @click="deleteBairro(item.id)" title="Excluir" type="danger" icon="el-icon-delete" size="mini" plain></el-button>
                        </td>
                    </tr>
                </tbody>
            </table>
            <div v-if="!statusList" class="u-text-center u-mt-25">
                <img src="/public/img/loading-bar.gif" />
            </div>
            <el-row :gutter="10" v-if="statusList">
                <el-col :xs="24" :sm="12" :md="12">
                    <div class="u-text-left u-mt-10">
                        Mostrando {{ paginate.from }} até {{ paginate.to }} de {{ paginate.qtdItens }} registros encontrados.
                    </div>
                </el-col>
                <el-col :xs="24" :sm="12" :md="12" v-if="paginate.qtdItens > 30">
                    <div class="u-text-right">
                            <el-pagination :current-page='paginate.page' class="u-mt-10" :total="paginate.qtdItens" @current-change="getPagePagination" :page-size="30" background layout="prev, pager, next" small></el-pagination>
                        </div>
                </el-col>
            </el-row>
        </div>

    </div>
</template>
<script>

export default {
    data: () => ({
        statusList: false,
        filtro: {
            nome: ''
        },
        paginate: {
            page: 1,
            qtdItens: null,
            from: '',
            to: ''
        },
        items: [ ]
    }),
    mounted () {
      this.loadingBairros()
    },
    methods: {
        loadingBairros(){

            this.statusList = false;
            this.items = [];

            this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/bairro/getAllPaginate?page=` + this.paginate.page, this.filtro, this.$store.getters.getHeaderAuth).then(response => {

                this.items = response.data.data;
                this.paginate.qtdItens = response.data.total;
                this.paginate.from = response.data.from;
                this.paginate.to = response.data.to;
                this.statusList = true;

            }).catch((error) => { this.$store.commit('throwException', error); });

        },
        deleteBairro(id){

            this.$msgbox.confirm('Tem certeza que deseja excluir esta bairro?', 'Atenção', { confirmButtonText: 'Sim', cancelButtonText: 'Não', type: 'warning' }).then(() => {

                window.eventBus.$emit('loading', true);
                    
                this.$axios.delete(`${this.$store.state.config.baseUrlApi}/api/bairro/delete/` + id, this.$store.getters.getHeaderAuth).then(response => {
                            
                    window.eventBus.$emit('loading', false);
                    window.eventBus.$emit('alert', {msg: 'Sucesso! - Operação realizada com Sucesso!', type: 'success'});
                    this.loadingBairros();

                }).catch((error) => { window.eventBus.$emit('loading', false); this.$store.commit('throwException', error); });

            }).catch(()=>{});

        },
        getPagePagination(page){
          this.paginate.page = page;
          this.loadingBairros();
        }
    },
    components:{  }
}
</script>